import * as React from "react";
import System from "src/helper/system";
import Helper from "src/support/Helper";
import ShowMoreLess from "./ShowMoreLess";

const DisplayLongDescriptionAndVariantMFRName = (props) => {
  const { currentProduct, no_show_more } = props;
  return (
    <>
      {currentProduct &&
        <>
          {currentProduct.ManufacturerName &&
            <div className="text-black-stone cursor-default">
              <div className="d-inline text-wrap w-auto">by&nbsp;</div>
              <a
                href={`/${System.siteName()}/manufacturers/m/${currentProduct?.ManufacturerName?.toLowerCase()
                  .replace(/\+/g, "and")
                  .replace(/\&/g, "and")
                  .replace(/\./g, "")
                  .replace(/\//g, "-")
                  .replace(/\,/g, "")
                  .replace(/\s/g, "-")
                  .replace(/\---/g, "-")}`}
                className="text-blue text-break cursor-pointer"
                title={currentProduct.ManufacturerName}
              >
                {currentProduct.ManufacturerName}
              </a>
            </div>
          }

          {currentProduct.ShortDescription &&
            <div className="summary more_summary mt-0 cursor-default">
              <ShowMoreLess
                single_product={currentProduct}
                no_show_more={no_show_more}
              />
            </div>
          }
        </>
      }
    </>
  );
};

export default DisplayLongDescriptionAndVariantMFRName;
